import React from 'react';
import { Alert } from 'react-bootstrap';
import { EMPTY_COUNT } from '../../utils/constants';

const ErrorAlert = (props) => {

    const RenderErrors = (
        props.errors.map((error, index) => {
            return <div key={index}><p className="mb-0">{error}</p></div>;
        })
    )

    return  EMPTY_COUNT < props.errors.length && <Alert bsStyle="danger" className={props.className}>{RenderErrors}</Alert>
};

export default ErrorAlert;